"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _components = require("@/components");
var _vuex = require("vuex");
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var _default = {
  name: 'NewServicesList',
  bodyClass: 'list-users-system-page',
  components: {
    Card: _components.Card,
    FieldSearchInput: _components.FieldSearchInput,
    TableUsersList: _components.TableUsersList
  },
  data: function data() {
    return {
      search: '',
      page: 1,
      perPage: 10,
      pages: []
    };
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)(['listAllUsers'])), {}, {
    list: function list() {
      return _lodash.default.orderBy(this.listAllUsers, ['Name']);
    },
    filterClients: function filterClients() {
      var _this = this;
      if (this.search.length) {
        return this.list.filter(function (p) {
          var name = p.personId.name || '';
          var CPF = p.personId.document || '';
          var mail = (p.personId.email || '').toUpperCase();
          return name.toUpperCase().indexOf(_this.search.toUpperCase()) >= 0 || CPF.indexOf(_this.search.toUpperCase()) >= 0 || mail.indexOf(_this.search.toUpperCase()) >= 0;
        });
      }
      return this.list;
    }
  }),
  created: function created() {
    this.fetchAllUsers();
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['fetchAllUsers'])), {}, {
    actionOpen: function actionOpen(item) {
      this.$router.push({
        path: "/users-detail/".concat(item.personId._id)
      });
    },
    addNew: function addNew() {
      this.$router.push({
        path: "/users-form"
      });
    }
  })
};
exports.default = _default;